var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _rect, _rect2, _rect3, _rect4, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _circle, _path62, _path63, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReserveMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 413,
    height: 185,
    viewBox: "0 0 413 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0342 120.183L66.9004 27.3394L67.9623 22.6906L178.136 48.3254L260.168 62.5374L296.671 112.835L285.256 110.354L332.909 120.714V176.632L261.097 181.281L194.462 179.023L122.12 181.281L102.607 179.023L97.4304 177.296H77.785H70.8826L42.742 174.374V155.912L41.0163 153.654V151.927L42.742 150.732V139.176H39.8217V120.183H37.0342Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.166 29.4645L110.306 105.97L192.824 115.424V112.901L111.501 102.251L68.4934 26.4095L67.166 29.4645Z",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.633 102.251L110.704 105.97",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M297.999 113.674L260.832 62.5375L68.2278 24.4171L37.1669 120.05H40.8836L69.5552 33.5819",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M119.332 124.698L192.825 130.665L193.487 177.049L119.332 179.023L98.6251 176.765H93.9792V127.488H98.6251L119.332 124.698Z",
    fill: "#B1D6DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M333.44 120.714L260.168 105.838L193.487 112.774V117.423V177.193",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8835 120.05V139.043H49.1149V151.396H40.8835V153.123L42.2109 154.717V163.815V174.109",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2109 172.913L64.1129 174.507L69.4224 173.843L93.9791 176.499L97.8285 175.968L120.261 177.695L196.586 176.101L260.168 179.82L332.909 173.71V119.518",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1401 139.575V151.396",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6439 174.507L64.3784 80.4685L86.6786 72.2335V121.112L68.2278 122.441L68.7588 173.843",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9974 76.4839V121.909",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1831 75.4211V121.909",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6344 120.979V79.1402L86.6785 77.812",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9975 81.2655L70.8826 82.9922L71.4135 121.909",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7136 175.57V127.089L97.8285 127.488L118.138 124.698L192.823 130.665V176.386",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118.536 107.697V124.699",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.253 127.488V176.632",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M204.088 129.339H194.811V169.892L204.088 170.422V129.339Z",
    fill: "#B1D6DE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.925 126.027V177.296",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M143.126 128.014V177.69",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M233.089 171.718V127.488L245.301 127.355V172.249L233.089 171.718Z",
    fill: "#B1D6DE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.269 128.285V177.164",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M176.258 129.339V177.82",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M260.168 105.838V179.82",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M194.811 129.339H204.088V170.422L194.811 170.29",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M229.904 127.621V171.452L245.567 172.116V127.222L229.904 127.621Z",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M233.355 127.488V171.585",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M284.194 169.991V129.878L322.157 133.863V167.733L284.194 169.991Z",
    fill: "#B1D6DE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M284.327 126.691V170.39L325.874 167.999V131.472L284.327 126.691Z",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M284.592 129.48L322.157 133.465L325.874 131.34",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M322.157 133.863V167.733",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M292.424 130.543V169.593",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M303.707 131.738V169.194",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M313.396 132.801V168.397",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M67.564 29.5972L110.704 105.837",
    stroke: "#8FA1AC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.0153 121.776V82.8594L71.5462 82.3281L74.9974 81.1327V121.776H71.0153Z",
    fill: "#B1D6DE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M81.8999 121.245V79.4059L86.5458 78.2104V121.245H81.8999Z",
    fill: "#B1D6DE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M180.259 134.395L129.155 159.631V163.616L180.259 134.395Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M321.494 144.223L291.627 159.1V161.49L321.494 144.223Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M183.047 143.028L131.942 168.264V172.249L183.047 143.028Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M322.688 148.739L292.822 163.616V166.006L322.688 148.739Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M191.807 115.667L260.168 109.424L332.113 123.769",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M87.6077 28.6678L119.465 85.1175L253.531 99.0639L223.492 56.2475L87.6077 28.6678Z",
    fill: "#8FA1AC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M367.483 135.629H364.562C365.51 135.499 366.378 135.37 367.246 135.176C401.741 128.9 398.978 103.927 398.978 103.927H401.899C401.82 103.927 404.741 130.129 367.483 135.629Z",
    fill: "#AABDC6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M389.402 176.628L383.293 176.628L383.293 90.1315L389.402 90.1315L389.402 176.628Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M358.904 176.628L354.981 176.628L354.981 128.215L358.904 128.215L358.904 176.628Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M381.079 121.583L381.144 176.628C381.144 177.201 381.877 177.647 382.52 177.647H389.439C390.083 177.647 390.597 177.201 390.597 176.628V115.024H405.902C406.545 115.024 407.06 114.579 407.06 114.005V110.376C407.06 109.803 406.545 109.357 405.902 109.357H396.706C396.32 109.93 397.092 108.784 396.706 109.357H395.034H390.597V105.281H397.671H399.214H408.346C408.989 105.281 409.504 104.835 409.504 104.262V100.632C409.504 100.059 408.989 99.6136 408.346 99.6136H404.102V97.1937C404.102 96.6206 403.587 96.1748 402.944 96.1748H398.7C398.057 96.1748 397.542 96.6206 397.542 97.1937V99.6136H390.468V90.1888C390.468 89.9978 390.404 89.8068 390.275 89.6157C389.954 89.17 389.439 88.8516 388.861 88.5968C387.896 88.2147 386.546 88.0237 385.259 88.0874C384.038 88.1511 382.816 88.4058 382.044 88.7879C381.98 88.7879 381.98 88.8516 381.915 88.8516C381.53 89.0426 381.272 89.2973 381.079 89.6157C380.951 89.7431 380.886 89.9341 380.886 90.1888V99.6136H371.433V97.0664C371.433 96.4932 370.919 96.0475 370.276 96.0475H366.031C365.388 96.0475 364.874 96.4932 364.874 97.0664V99.6136H362.623C361.98 99.6136 361.465 100.059 361.465 100.632V104.262C361.465 104.835 361.98 105.281 362.623 105.281H364.038H365.581H381.079V109.357H365.903C365.903 109.357 365.838 109.357 365.774 109.357C365.131 109.357 364.617 109.803 364.617 110.376V114.005C364.617 114.579 365.131 115.024 365.774 115.024H381.079V120.182V121.583ZM383.33 90.5709C383.78 90.3162 384.616 90.1888 385.452 90.1252C386.417 90.0615 387.317 90.1888 387.96 90.4436C388.089 90.5073 388.153 90.5073 388.218 90.5709V175.785H383.266L383.33 90.5709ZM407.253 101.651V103.243H390.533V101.651H407.253ZM404.745 111.395V112.987H390.533V111.331L404.745 111.395ZM366.932 112.987V111.395H381.079V113.05H366.932V112.987ZM363.973 103.243V101.651H381.079V103.243H363.973ZM369.375 98.7857H367.382V98.0853H369.375V98.7857ZM401.851 98.9131H399.857V98.2126H401.851V98.9131Z",
    fill: "#AABDC6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M353.683 147.439V176.628C353.683 176.947 354.005 177.265 354.391 177.265H358.699C359.085 177.265 359.407 177.01 359.407 176.628V143.491H368.667C369.053 143.491 369.375 143.236 369.375 142.854V140.689C369.375 140.37 369.053 140.052 368.667 140.052H363.137C362.879 140.434 363.394 139.733 363.137 140.052H362.108H359.407V137.632H363.715H364.68H370.211C370.596 137.632 370.918 137.377 370.918 136.995V134.83C370.918 134.512 370.596 134.193 370.211 134.193H367.638V132.728C367.638 132.41 367.317 132.092 366.931 132.092H364.359C363.973 132.092 363.651 132.346 363.651 132.728V134.193H359.407V128.526C359.407 128.398 359.343 128.271 359.278 128.207C359.085 127.952 358.764 127.761 358.442 127.57C357.863 127.316 357.027 127.252 356.256 127.252C355.484 127.252 354.777 127.443 354.327 127.698H354.262C354.069 127.825 353.876 127.952 353.748 128.143C353.683 128.207 353.619 128.335 353.619 128.462V134.129H347.96V132.665C347.96 132.346 347.638 132.028 347.253 132.028H344.68C344.294 132.028 343.973 132.283 343.973 132.665V134.193H342.622C342.237 134.193 341.915 134.448 341.915 134.83V136.995C341.915 137.314 342.237 137.632 342.622 137.632H343.458H344.423H353.683V140.052H344.552H344.487C344.102 140.052 343.78 140.306 343.78 140.689V142.854C343.78 143.172 344.102 143.491 344.487 143.491H353.683V146.611V147.439ZM355.034 128.717C355.291 128.589 355.806 128.462 356.32 128.462C356.899 128.462 357.478 128.526 357.863 128.653C357.928 128.653 357.992 128.717 357.992 128.717V175.785H356.481H354.97L355.034 128.717ZM369.439 135.403V136.358H359.343V135.403H369.439ZM367.96 141.262V142.217H359.407V141.262H367.96ZM345.13 142.217V141.262H353.683V142.217H345.13ZM343.394 136.358V135.403H353.683V136.358H343.394ZM346.61 133.684H345.452V133.302H346.61V133.684ZM366.223 133.747H365.066V133.302H366.223V133.747Z",
    fill: "#AABDC6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M346.098 136.422H344.105C344.748 136.295 345.326 136.168 345.905 135.977C369.249 129.8 367.384 105.283 367.384 105.283H369.378C369.313 105.283 371.307 131.073 346.098 136.422Z",
    fill: "#AABDC6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M404.771 112.983L390.559 112.983L390.559 111.327L404.771 111.327L404.771 112.983Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 343.047,
    y: 135.628,
    width: 10.19,
    height: 1.13222,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 345.312,
    y: 141.29,
    width: 7.92553,
    height: 1.13222,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 358.895,
    y: 135.628,
    width: 10.19,
    height: 1.13222,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 360.027,
    y: 141.29,
    width: 7.92553,
    height: 1.13222,
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M404.203 175.592H337.543L264.919 181.689L201.439 177.978L125.237 179.568L102.84 177.845L98.9967 178.375L74.4795 175.725L69.1785 176.388L47.3118 174.797H6.62646",
    stroke: "#8FA1AC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4483 0.0146945C94.6285 -0.118586 93.9453 0.681095 94.3552 1.3475L114.44 38.6659L132.066 71.3195C132.339 71.9859 133.022 72.3858 133.706 72.3858L265.42 88.7792C266.24 88.9125 266.786 87.9796 266.376 87.3132L225.976 25.0445C225.976 25.0445 225.566 24.6447 225.293 24.6447L95.4483 0.0146945Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M130.538 6.7533L168.308 76.3292",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M164.994 13.3798L202.764 81.6304",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M197.463 19.3429L235.895 86.9309",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M112.647 33.9208L244.51 54.4622",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2294 179.673V131.265L18.41 130.085L39.6622 125.362L49.6979 129.494V180.854L41.4332 183.215L19.0004 180.854L17.2294 179.673Z",
    fill: "url(#paint0_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2305 131.265L17.2306 179.083C17.2306 179.083 17.1136 181.01 19.2059 181.01L39.686 183.328C39.686 183.328 41.5321 183.401 41.3721 181.328V126.438C41.3721 126.438 41.1198 125.362 38.5229 125.362L18.6151 130.189C18.6151 130.189 17.2305 130.189 17.2305 131.265Z",
    fill: "url(#paint1_linear)",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2284 139.468L41.0829 135.493",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8422 125.953L49.6972 129.495V181.444L40.2518 183.215",
    stroke: "black",
    strokeWidth: 2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.8308 142.104C27.8308 141.62 28.1781 141.205 28.655 141.12L29.3055 141.003C29.9185 140.894 30.4813 141.365 30.4813 141.988V146.225C30.4813 146.848 29.9185 147.319 29.3055 147.21L28.655 147.094C28.1781 147.008 27.8308 146.594 27.8308 146.109V142.104Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 382.336,
    cy: 131.863,
    r: 23.192,
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M399.418 126.417L387.2 126.514L395.151 96.7444L378.472 120.308L392.921 134.854L399.418 126.417Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M408.823 157.864C409.201 157.471 409.194 156.848 408.809 156.463L356.974 104.723C356.583 104.333 355.951 104.334 355.56 104.724L354.551 105.733C354.16 106.124 354.161 106.758 354.553 107.149L373.412 125.917C373.758 126.262 373.805 126.806 373.522 127.205L369.91 132.288C369.437 132.953 369.917 133.874 370.734 133.867L378.781 133.799C379.45 133.793 379.935 134.433 379.75 135.075L373.338 157.331C373.032 158.392 374.418 159.092 375.091 158.217L387.669 141.866C388.037 141.387 388.742 141.341 389.169 141.768L406.358 158.957C406.754 159.353 407.398 159.347 407.786 158.943L408.823 157.864Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 33.4636,
    y1: 125.362,
    x2: 33.4636,
    y2: 183.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56A662"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 29.3057,
    y1: 125.362,
    x2: 29.3057,
    y2: 183.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56A662"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserveMode);
export default __webpack_public_path__ + "static/media/reserve-mode.ae87e26cd3ba9516e75ff25b9f6d1659.svg";
export { ForwardRef as ReactComponent };